import { useNavigate } from "react-router-dom";
import Header from "../components/Header";

function Enrichment() {
  const navigate = useNavigate();

  const resources = [
    {
      title: "Canine Enrichment Guide",
      link: "https://drive.google.com/file/d/1ZpK7FjD-TlUYnKweyUtrlQu5AZ69YerD/view?usp=sharing",
    },
  ];

  return (
    <>
      <Header />
      <div className="min-h-screen bg-gray-50 p-8">
        <button
          onClick={() => navigate("/home")}
          className="mb-6 inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 shadow-sm"
        >
          ← Back to Dashboard
        </button>

        <h1 className="text-4xl font-bold text-gray-800 mb-2">Enrichment</h1>
        <p className="text-lg text-gray-600 mb-8">
          Ideas and strategies to keep your dog mentally stimulated, relaxed, and fulfilled.
        </p>

        <div className="grid sm:grid-cols-2 gap-4">
          {resources.map(({ title, link }) => (
            <a
              key={title}
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              className="block p-5 bg-white border border-gray-200 rounded-xl text-blue-600 hover:border-blue-400 hover:shadow transition text-center font-medium"
            >
              {title}
            </a>
          ))}
        </div>
      </div>
    </>
  );
}

export default Enrichment;
